import { render, staticRenderFns } from "./PublicationField.vue?vue&type=template&id=fb0d3d16&scoped=true&"
import script from "./PublicationField.vue?vue&type=script&lang=js&"
export * from "./PublicationField.vue?vue&type=script&lang=js&"
import style0 from "./PublicationField.vue?vue&type=style&index=0&id=fb0d3d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0d3d16",
  null
  
)

export default component.exports